import * as selectors from './sources-selectors';

export const Sources = {
    ...selectors,
} as const;
